import {
    HttpEvent,
    HttpEventType,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { FolderType } from '@models';
import { HEADER_PREFIX } from '@services/generics/constants';

import {
    Observable,
    of,
    throwError,
} from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const FOLDER_PATH_PARAM_NAME = 'FolderPath-Encoded';
export const FOLDER_PATH_HEADER_NAME = `${HEADER_PREFIX}-${FOLDER_PATH_PARAM_NAME}`;

export class MonitoringInterceptor implements HttpInterceptor {
    constructor(private _appState: AppStateFacade) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const options = {
            url: request.url,
            setHeaders: {} as any,
            withCredentials: true,
        };

        // move query param folder path to header for Modern Folders (and remove for classic)
        const folderPath = request.params.get(FOLDER_PATH_HEADER_NAME);
        if (folderPath) {
            request = request.clone({ params: request.params.delete(FOLDER_PATH_HEADER_NAME) });

            if (this._appState.user.folder.type === FolderType.Modern) {
                options.setHeaders[FOLDER_PATH_HEADER_NAME] = folderPath;
            }
        }

        return next.handle(request.clone(options)).pipe(
            // FIXME: workaround for BE endpoints that return null
            // remove when all issues are resolved
            switchMap(event => {
                if (
                    event.type === HttpEventType.Response &&
                    event.ok &&
                    event.body === 'null'
                ) {
                    return throwError(new Error());
                }
                return of(event);
            }),
        );
    }
}
